module.exports = __webpack_public_path__ + "images/aspire_small3af3dc3cc29b65ff3e8c99f3b0b202fa.png";